const { TextControl, Panel, PanelBody, Button, IconButton } = wp.components;

export const TextRepeaterPanel = ( {props, attributeKey, label} ) => {

    if (props == undefined) {
        return null;
    }

    var repeaterFields;

    const handleRepeaterFieldChange = ( text, index ) => {
        const repeaterFields = [ ...props.attributes[ attributeKey ] ];
        repeaterFields[ index ] = text;
        props.setAttributes({ [attributeKey]: repeaterFields })
    }

    const handleAddRepeaterField = () => {
        const repeaterFields = [ ...props.attributes[ attributeKey ] ];
        repeaterFields.push( '' );
        props.setAttributes({ [attributeKey]: repeaterFields })
    }

    const handleRemoveRepeaterField = ( index ) => {
        const repeaterFields = [ ...props.attributes[ attributeKey ] ];
        repeaterFields.splice( index, 1 );
        props.setAttributes({ [attributeKey]: repeaterFields })
    }

    if ( props.attributes[attributeKey].length ) {
        repeaterFields = props.attributes[attributeKey].map( ( value, index ) => {
            return <div className={'repeater-entry'} key={ index }>
                <TextControl
                    placeholder="..."
                    value={ props.attributes[attributeKey][ index ] }
                    onChange={ ( text ) => handleRepeaterFieldChange( text, index ) }
                />
                <IconButton
                    icon="no-alt"
                    label={"Ta bort " + label}
                    onClick={ () => handleRemoveRepeaterField( index ) }
                />
            </div>;
        } );
    }

    return (
        <Panel>
            <PanelBody title={ label }>
            { repeaterFields }
                <Button
                    isDefault
                    onClick={ handleAddRepeaterField.bind( this ) }
                >
                    { 'Lägg till ' + label }
                </Button>
            </PanelBody>
        </Panel>
    );

}